import { replaceEmojiShortcodes } from "@/lib/emoji/shortcodeToUnicode";

type MdNode = {
  type?: string;
  value?: unknown;
  children?: MdNode[];
};

const CODE_NODE_TYPES = new Set(["code", "inlineCode"]);

const visit = (node: MdNode, isInCode: boolean): void => {
  if (!node || typeof node !== "object") {
    return;
  }

  const currentIsInCode = isInCode || CODE_NODE_TYPES.has(node.type ?? "");

  if (
    !currentIsInCode &&
    node.type === "text" &&
    typeof node.value === "string"
  ) {
    node.value = replaceEmojiShortcodes(node.value);
  }

  if (!Array.isArray(node.children)) {
    return;
  }

  for (const child of node.children) {
    visit(child, currentIsInCode);
  }
};

export const remarkEmojiShortcodeCompat = () => {
  return (tree: MdNode): void => {
    visit(tree, false);
  };
};
